import { render, staticRenderFns } from "./tulipan.vue?vue&type=template&id=1981bd8c&scoped=true"
var script = {}
import style0 from "./tulipan.vue?vue&type=style&index=0&id=1981bd8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1981bd8c",
  null
  
)

export default component.exports